import React, { useEffect } from "react";
import { Outlet, Route, Routes, Navigate } from "react-router-dom";
import Auth from "../pages/auth";
import SideMenu from "components/sideMenu/SideMenu";
import DashboardHeader from "components/dashboardHeader/DashboardHeader";
import ResetPassword from "pages/auth/resetPassword/ResetPassword";
import ChangePassword from "pages/changePassword/ChangePassword";
import { toastMessage } from "utils/toastMessage";
import { routes } from "./routes";
import { useDispatch, useSelector } from "react-redux";
import { setPersonalInfo } from "store/slices/userDataStore";
import NotFound from "components/notFound/NotFound";

const Routing = () => {
  const dispatch = useDispatch();
  const { personalInfo } = useSelector((state) => state.config);
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("adminInfo"));
    dispatch(setPersonalInfo({ personalInfo: data }));
  }, []);

  const DashboardRoutes = () => {
    return (
      <>
        <section className="dashboard_section">
          <div className="sidebar_section">
            <SideMenu />
          </div>
          <div className="main_content">
            <DashboardHeader />
            <div className="dashboard_content">
              <Outlet />
            </div>
          </div>
        </section>
      </>
    );
  };
  const ProtectedRoute = ({ children }) => {
    if (!localStorage.getItem("token")) {
      return (
        <>
          <Navigate to="/" replace />
          {toastMessage("session Expire Login again", "error", "tokenMissing")}
        </>
      );
    } else {
      return children;
    }
  };
  return (
    <>
      <Routes>
        <Route path="/" element={<Auth />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="*" element={<NotFound />} />
        <Route path="" element={<DashboardRoutes />}>
          {routes(personalInfo) && routes(personalInfo).length > 0
            ? routes(personalInfo).map((data, index) => {
                return (
                  <Route
                    key={index}
                    path={data?.path}
                    element={<ProtectedRoute>{data?.element}</ProtectedRoute>}
                  />
                );
              })
            : null}
          {/* <Route
            path="/dashboard/students-management"
            element={<ProtectedRoute>{<StudentManagement />}</ProtectedRoute>}
          />
          <Route
            path="/dashboard/students-management/edit"
            element={
              <ProtectedRoute>{<EditStudentManagement />}</ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/teacher-management"
            element={<ProtectedRoute>{<TeacherManagement />}</ProtectedRoute>}
          />
          <Route
            path="/dashboard/teacher-management/edit"
            element={
              <ProtectedRoute>{<EditTeacherManagement />}</ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={<ProtectedRoute>{<Dashboard />}</ProtectedRoute>}
          /> */}
          <Route path="/change-password" element={<ChangePassword />} />
        </Route>
      </Routes>
    </>
  );
};
export default Routing;
